<div class="row mb-3 mt-2">
  <div class="col-12 col-md-6">
    <button class="btn btn-secondary text-white m-r-10" (click)="activeChange.emit(false)">Volver</button>
   </div>
   <div class="col-12 col-md-6 ">
    <div class="mb-3 d-md-flex justify-content-end fw-bold">
        <div class="mt-md-0 "><a (click)="syncDepartaments()" class="text-decoration-none text-dark" role="button" style="cursor: pointer;"><i
                    class="fa fa-sync fa-fw me-1 text-dark text-opacity-50"></i> Sincronizar departamentos Aasinet</a>
        </div>
    </div>
</div>
</div>

<div class="row">
  <div class="col-12 col-lg-7">
    <div class="panel p-4">
      <h5>Departamentos Configurados</h5>
      <div class="table-responsive table-data mt-2">
        <table class="table table-sm table-striped">
          <thead>
          <tr>
            <th class="text-nowrap" style="width: 100px;">Código</th>
            <th>Subdepartamento</th>
            <th>Origen</th>
            <th class="text-nowrap text-center" style="width: 70px;">Activo</th>
            <th class="text-nowrap text-center"><i class="fas fa-cog"></i></th>
          </tr>
        </thead>

        @for (group of groupedDepartments; track group.parentCode) {         

         
          <tr class="table-group-header">
            <th colspan="5" class="fw-bold" style="height: 32px;">
             {{ group.parentName }}
            </th>
          </tr> 
        <tbody>


          @for (sub of group.departments; track sub.departamentCode+sub.departamentFundCode) {
          <tr>
            <td class="text-nowrap align-middle" style="height: 34px;">{{ sub.departamentCode }}</td>
            <td class="align-middle">{{ sub.displayName }}</td>
            <td class="align-middle">{{ sub.departamentFundCode }}</td>
            <td class="text-nowrap align-middle text-center">
              <input class="form-check-input" type="checkbox" [checked]="sub.isActive" (change)="updateDepartamentCheck(sub, 'isActive', !sub.isActive)">
            </td>
            <td class="text-nowrap">
              <div class="d-flex gap-1 justify-content-center">
                <button class="btn btn-outline-primary btn-xs" (click)="setFormDepartament(sub)"><i class="fas fa-pencil-alt"></i></button>
                @if(budgetVersionSelected.entityGroup=='IASD'){
                <button class="btn btn-outline-danger btn-xs" (click)="deleteDepartament(sub)"><i class="fas fa-trash"></i></button>
                }
              </div>
            </td>
          </tr>
          }

          @empty {
          <tr>
            <td colspan="5" class="text-muted">Sin subdepartamentos.</td>
          </tr>
          }
        </tbody>
        }

        @empty {
        <tbody>
          <tr>
            <td colspan="5" class="text-center">No hay departamentos para mostrar.</td>
          </tr>
        </tbody>
        }
      </table>
    </div>
    </div>
  </div>
  
  <div class="col-12 col-lg-5">
    <div class="panel p-4">
      <h5 class="">Agregar Departamentos</h5>
      <div class="form-group row">
        <label class="col-md-4 col-form-label mt-2">Departamento Origen</label>
        <div class="col-md-8">
         <select class="form-select" [(ngModel)]="selectedOrigin" (change)="changeOrigin()">
          @for(dr of departamentPlanVersionRevenue; track dr.departamentCode;let i=$index){
          <option value="{{dr.departamentCode}}" [selected]="i==0">{{dr.departamentCode}} - {{dr.displayName}}</option>
          }
         </select>
        </div>
      </div>
      <br>
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Departamento Destino</label>
        <div class="col-md-8">
          <ng-select [items]="departament" [hideSelected]="true" [(ngModel)]="selectedDestination" [closeOnSelect]="false" [clearable]="false"
          [multiple]="true" bindLabel="nameCode" groupBy="parentName" [selectableGroup]="false" 
          [selectableGroupAsModel]="false" bindValue="departamentCode" (add)="addDepartament($event)" placeholder="Seleccione un departamento"
          (blur)="blurNgSelect()">
        </ng-select>
          
        </div>
      </div>
    </div>
  </div>
</div>



@if(false){

  <div class="row mb-3 mt-2">
    <div class="col-8 col-md-3">
      <button class="btn btn-secondary text-white m-r-10" (click)="activeChange.emit(false)">Volver</button>
     </div>
  
    <div class="col-4 col-md-9 d-flex justify-content-end">
      <button class="btn btn-success text-white m-r-10" (click)="openModalDepartament()">Agregar Departamento</button>
    </div>
  </div>

<div class="panel p-4 ">

  <div class="table-responsive table-data">
      <table class="table table-sm table-striped ">
          <thead>
              <tr>
                  <th class="text-nowrap " style="width: 80px;">N° Codigo</th>
                  <th>Nombre Departamento </th>
                  <th>Departamento Origen</th>
                  <th class="text-nowrap ">Notas</th>                 
                  <th class="text-nowrap text-center">Permite Diezmo</th>
                  <th class="text-nowrap text-center">Activo</th>
                  <th class="text-nowrap text-center"><i class="fas fa-cog"></i></th>                   
              </tr>
          </thead>
          <tbody>
              @for(a of dataSource; track a){
              <tr>
                  <td class="text-nowrap align-middle  text-center"style="height: 34px;">{{a.departamentCode}}
                  </td>
                  <td class=" align-middle">{{a.displayName}}</td>
                  <td class="text-nowrap align-middle">{{a.departamentFundCode}}</td>
                  <td class="text-nowrap align-middle">
                      <span >{{a.hint}}</span>
                  </td>
                       <td class="text-nowrap align-middle text-center">
                    <span > <input class="form-check-input" type="checkbox" [checked]="a.allowsTithe" (change)="updateDepartamentCheck(a,'allowsTithe',!a.allowsTithe)"> </span>
                </td>
                <td class="text-nowrap align-middle text-center">
                  <span > <input class="form-check-input" type="checkbox" [checked]="a.allowsNonTithe" (change)="updateDepartamentCheck(a,'allowsNonTithe',!a.allowsNonTithe)"> </span>
              </td>
              <td class="text-nowrap align-middle text-center">
                <span > <input class="form-check-input" type="checkbox" [checked]="a.isActive" (change)="updateDepartamentCheck(a,'isActive',!a.isActive)"> </span>
            </td>
      
                  <td class="text-nowrap">
                    <div class="d-flex gap-1 justify-content-center">
                      <button class="btn btn-outline-primary btn-xs" (click)="setFormDepartament(a)"><i class="fas fa-pencil-alt"></i></button>
                      @if(budgetVersionSelected.entityGroup=='IASD'){
                      <button class="btn btn-outline-danger btn-xs" (click)="deleteDepartament(a)"><i class="fas fa-trash"></i></button>
                      }
                    </div>
                  </td>
                
              </tr>
              }
          </tbody>
      </table>
  </div>
  
  
  
  
  
  </div>
} 

<br>



<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{titleModal}}</h5>
    <button (click)="d('Cross click');resetForm()" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
      <span></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formDepartamentPlan">
         <div class="form-group row">
        <label class="col-md-4 col-form-label">Nombre para mostrar</label>
        <div class="col-md-8">
          <input type="text" #nameInput class="form-control" tabindex="2"
            [class.is-invalid]="formDepartamentPlan.get('displayName').invalid&&formDepartamentPlan.get('displayName').touched"
            (click)="formDepartamentPlan.get('displayName').markAsUntouched();"
            (focus)="formDepartamentPlan.get('displayName').markAsUntouched();" formControlName="displayName"
            name="displayName" class="form-control" tabindex="2" />
          @if(formDepartamentPlan.get('displayName')?.errors?.required &&
          formDepartamentPlan.get('displayName').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Código</label>
        <div class="col-md-8">
          <ng-select #ngSelect [hideSelected]="true" [items]="departament" bindLabel="nameCode" [closeOnSelect]="true"
            [dropdownPosition]="'bottom'" bindValue="departamentCode" groupBy="parentName" placeholder="Escribe un departamento o codigo"
            formControlName="departamentCode" name="departamentCode"  tabindex="1"
            (close)="closeNgSelect(ngSelect)">
          </ng-select>
          @if(formDepartamentPlan.get('departamentCode')?.errors?.required &&
          formDepartamentPlan.get('departamentCode').touched){
          <div><small class="text-danger">Cuenta es requerida.</small></div>
          }
        </div>
      </div>&nbsp;
  
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Restricción</label>

        <div class="col-md-8 d-flex align-items-center">
          <div class="d-flex gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="check1" formControlName="allowsTithe" name="allowsTithe"  tabindex="3">
              <label class="form-check-label" for="check1">Solo Diezmo</label>
            </div>
            
          </div>
        </div>
      </div>
      
      <div class="form-group row mt-2">
        <label class="col-md-4 col-form-label">Nota</label>
        <div class="col-md-8">
          <textarea type="text"
            [class.is-invalid]="formDepartamentPlan.get('hint').invalid&&formDepartamentPlan.get('hint').touched"
            (click)="formDepartamentPlan.get('hint').markAsUntouched();"
            (focus)="formDepartamentPlan.get('hint').markAsUntouched();" formControlName="hint" name="hint"
            class="form-control" tabindex="5" rows="5">
          </textarea>
          @if(formDepartamentPlan.get('hint')?.errors?.required && formDepartamentPlan.get('hint').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>&nbsp;

    </form>
  </div>
  <div class="modal-footer">
    @if(formDepartamentPlan.errors){
    <div><small class="text-danger">{{formDepartamentPlan.errors | json }}</small></div>
    }
    <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
      class="fas fa-times"></i>&nbsp; Cerrar</button>
    @if(titleModal=='Editar Departamento'){
   
    <button type="button" class="btn btn-primary btn-sm" (click)="submitUpdate()"
      
      tabindex="6"><i class="fas fa-save"></i>&nbsp;Guardar</button>
    }
    @else{
      <button type="button" class="btn btn-primary btn-sm" (click)="submitNewDepartament()"
      
      tabindex="6"><i class="fas fa-save"></i>&nbsp;Guardar</button>
    }


  </div>

</ng-template>